import BadgePill from '@/components/BadgePill'

type GiftBadgeProps = {
  className?: string
}

export default function GiftBadge({ className = '' }: GiftBadgeProps) {
  return (
    <BadgePill
      className={`custom_gift_glow bg-[#14b8a6] text-white ${className}`.trim()}
    >
      ПОДАРОК
    </BadgePill>
  )
}
